import Page from "../components/Page";
import Logo from "../assets/logo.svg";
import LogoDark from "../assets/LogoDark.svg"
import { subscriptionPrice } from '../config/config';
import React from "react";
import { toast } from "react-hot-toast";
import { getUserDetailsInLocalStorage } from "../helpers/UserDetails";
import AppBarDropdown from "../components/AppBarDropdown";
import { useTranslation } from "react-i18next";
import { useTheme } from "../contexts/ThemeContext";
import { usePublicWebsiteData } from "../controllers/website_crm.controller";

export default function InActiveSubscriptionPage() {
  const { t } = useTranslation();
  const user = getUserDetailsInLocalStorage();
  const {theme} = useTheme();
  const { data: publicData, isLoading } = usePublicWebsiteData();

  const handleTryDemo = () => {
    // Get user details for personalized message
    const userName = user?.name || 'New Customer';
    const userEmail = user?.email || 'Not provided';
    const userBusiness = user?.biz_name || 'Not provided';
    
    // Create the WhatsApp message for demo
    const message = `Hello! I want to try the eHospitalityNepal demo for 2 days.\n\n` +
                   `My Details:\n` +
                   `• Name: ${userName}\n` +
                   `• Email: ${userEmail}\n` +
                   `• Business: ${userBusiness}\n\n` +
                   `Please provide me with demo access and setup instructions.`;
    
    // Encode the message for URL
    const encodedMessage = encodeURIComponent(message);
    
    // WhatsApp API URL
    const whatsappUrl = `https://wa.me/+9779708038238?text=${encodedMessage}`;
    
    // Open WhatsApp
    window.open(whatsappUrl, '_blank');
    
    toast.success("Opening WhatsApp for demo request...");
  };

  const handleWhatsAppSubscription = () => {
    // Get user details for personalized message
    const userName = user?.name || 'New Customer';
    const userEmail = user?.email || 'Not provided';
    const userBusiness = user?.biz_name || 'Not provided';
    
    // Create the WhatsApp message
    const message = `Hello! I want to purchase a subscription for eHospitalityNepal.\n\n` +
                   `My Details:\n` +
                   `• Name: ${userName}\n` +
                   `• Email: ${userEmail}\n` +
                   `• Business: ${userBusiness}\n` +
                   `• Plan: Professional (${subscriptionPrice}/month)\n\n` +
                   `Please provide me with the payment details and activation process.`;
    
    // Encode the message for URL
    const encodedMessage = encodeURIComponent(message);
    
    // WhatsApp API URL
    const whatsappUrl = `https://wa.me/+9779708038238?text=${encodedMessage}`;
    
    // Open WhatsApp
    window.open(whatsappUrl, '_blank');
    
    toast.success("Opening WhatsApp for subscription...");
  };

  return (
    <Page className="">
      <div className="flex items-center justify-between px-4 py-3 border-b border-restro-gray">
        <img src={theme === "black" ? LogoDark : Logo} alt="logo" className="h-12 block" />
        <AppBarDropdown />
      </div>

      {user.role == "admin" ? (
        <>
          <h3 className="mt-4 text-center text-xl font-semibold">
            {t("inactive_subscription.no_active_subscription_admin")}
          </h3>
          <p className="text-center text-gray-600 mt-2">
            Choose your preferred option to get started
          </p>
          
          <div className="w-full container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 my-20 gap-10 place-items-center px-6 lg:px-0">
            {isLoading ? (
              <p>Loading packages...</p>
            ) : publicData?.packages?.filter(p => p.is_active)?.length > 0 ? (
              publicData.packages.filter(p => p.is_active).map((pkg) => (
                <div key={pkg.id} className={`rounded-2xl px-8 py-6 border flex flex-col w-full ${pkg.is_popular ? 'border-blue-500 shadow-xl scale-105' : 'border-restro-border-green'} h-full relative`}>
                  {pkg.is_popular == 1 && (
                    <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-blue-500 text-white px-4 py-1 rounded-full text-xs font-bold">
                      POPULAR
                    </div>
                  )}
                  <h3 className={`text-4xl font-bold text-center ${pkg.is_popular ? 'text-blue-700' : 'text-green-700'}`}>{pkg.price}</h3>
                  <h3 className="font-bold text-2xl text-center mt-2">{pkg.name}</h3>
                  <p className="text-center text-gray-500 font-semibold mb-4">{pkg.duration}</p>
                  
                  <ul className="text-gray-700 dark:text-white mt-6 flex flex-col gap-2 text-start flex-1">
                    {pkg.features?.split('\n').map((feature, idx) => (
                      <li key={idx}>✅ {feature}</li>
                    ))}
                  </ul>
                  
                  {/* Try Demo Button */}
                  <button 
                    onClick={handleTryDemo}
                    className="w-full rounded-xl bg-blue-600 text-white px-4 py-3 transition active:scale-95 hover:bg-blue-700 mt-6 flex items-center justify-center gap-2 font-semibold"
                  >
                    Try Free Demo
                  </button>

                  {/* WhatsApp Subscription Button */}
                  <button 
                    onClick={() => {
                      const userName = user?.name || 'New Customer';
                      const userEmail = user?.email || 'Not provided';
                      const userBusiness = user?.biz_name || 'Not provided';
                      const message = `Hello! I want to purchase a subscription for eHospitalityNepal.

My Details:
• Name: ${userName}
• Email: ${userEmail}
• Business: ${userBusiness}
• Plan: ${pkg.name} (${pkg.price})

Please provide me with the payment details and activation process.`;
                      window.open(`https://wa.me/+9779708038238?text=${encodeURIComponent(message)}`, '_blank');
                    }}
                    className={`w-full rounded-xl text-white px-4 py-3 transition active:scale-95 mt-4 flex items-center justify-center gap-2 font-semibold ${pkg.is_popular ? 'bg-blue-600 hover:bg-blue-700' : 'bg-green-600 hover:bg-green-700'}`}
                  >
                    Subscribe Now
                  </button>
                </div>
              ))
            ) : (
              <p>No packages found.</p>
            )}
          </div>
        </>
      ) : (
        <div>
          <h3 className="mt-4 text-center">{t("inactive_subscription.no_active_subscription_user")}</h3>
        </div>
      )}
    </Page>
  );
}